import React, { FC } from "react"
import { Container } from "@components/styles"
import { ContentWrapper, ContentLeft, ContentRight } from "./styles"
import { ContentTwoColumnsProps } from "./types"

const ContentTwoColumns: FC<ContentTwoColumnsProps> = ({
    contentLeft,
    contentRight
}) => {
    return <Container>
        <ContentWrapper>
            <ContentLeft dangerouslySetInnerHTML={{ __html: `${contentLeft}` }} />
            <ContentRight dangerouslySetInnerHTML={{ __html: `${contentRight}` }} />
        </ContentWrapper>
    </Container>
}

export default ContentTwoColumns
